import type { Sponsor } from '@shared-types/sponsor.types';
import { language } from '@utilities/browser';

export const getLink = (sponsor: Sponsor): string => {
  const link = sponsor?.links?.[language.toUpperCase()] ?? sponsor?.links?.['EN'] ?? '';
  return link.toLowerCase().startsWith('http') ? link : null;
};

export const findSponsorsByName = (sponsors: Sponsor[], sponsorName: string) =>
  sponsors?.find((s) => s.mainSponsor === sponsorName || s.name === sponsorName || s.tags?.includes(sponsorName));
